module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_add-to-unscopables.js
// module id = 1091
// module chunks = 1